let pages = [];
let folders = [];
let globals = [];
let settings = {};
let activePageId = null;
let properties = {};
let siteName = null;
let customColorPalettes = [];
let customTextColors = [];
let customColors = [];
let customFontPairs = [];
let customGradients = [];
let currentColorPaletteVersion = null;
let cleanUrlsEnabled = false;
let redirects = [];
let integrations = {};
let currentButtonPresetVersion = null;

const getPages = () => pages;
const setPages = (newPages) => {
  pages = newPages;
};

const getFolders = () => folders;
const setFolders = (newFolders) => {
  folders = newFolders;
};

const setPageHtml = (pageId, html) => {
  const page = pages.find((p) => p.id === pageId);
  page.html = html;
};

const getActivePageId = () => activePageId;
const setActivePageId = (newActivePageId) => {
  activePageId = newActivePageId;
};

const getGlobals = () => globals;
const setGlobals = (newGlobals) => {
  globals = newGlobals;
};

const getGlobalHtml = (globalId) => globals.find((p) => p.id === globalId).html;
const setGlobalHtml = (globalId, html) => {
  const global = globals.find((p) => p.id === globalId);
  global.html = html;
};

const getSettings = () => settings;
const setSettings = (newSettings) => {
  settings = newSettings;
};

const getRedirects = () => redirects;
const setRedirects = (newRedirects) => {
  redirects = newRedirects;
};

const getProperties = () => properties;
const setProperties = (newProperties) => {
  properties = newProperties;
};

const setProperty = (property, value) => {
  properties = { ...properties, [property]: value };
};

const getSiteName = () => siteName;
const setSiteName = (newName) => {
  siteName = newName;
};

const getCustomColorPalettes = () => customColorPalettes;
const setCustomColorPalettes = (palettes) => {
  customColorPalettes = palettes;
};

const getCurrentColorPaletteVersion = () => currentColorPaletteVersion;
const setCurrentColorPaletteVersion = (value) => {
  currentColorPaletteVersion = value;
};

const getCurrentButtonPresetVersion = () => currentButtonPresetVersion;
const setCurrentButtonPresetVersion = (value) => {
  currentButtonPresetVersion = value;
};

const getCustomTextColors = () => customTextColors;
const setCustomTextColors = (value) => {
  customTextColors = value;
};

const getCustomColors = () => customColors;
const setCustomColors = (value) => {
  customColors = value;
};

const getCustomFontPairs = () => customFontPairs;
const setCustomFontPairs = (value) => {
  customFontPairs = value;
};

const getCustomGradients = () => customGradients;
const setCustomGradients = (value) => {
  customGradients = value;
};

const getCleanUrlsEnabled = () => cleanUrlsEnabled;
const setCleanUrlsEnabled = (value) => {
  cleanUrlsEnabled = value;
};

const getIntegrations = () => integrations;
const setIntegrations = (newIntegrations) => {
  integrations = newIntegrations;
};

export default {
  getPages,
  setPages,
  getFolders,
  setFolders,
  setPageHtml,
  getActivePageId,
  setActivePageId,
  getGlobals,
  setGlobals,
  setGlobalHtml,
  getGlobalHtml,
  setSettings,
  getSettings,
  setProperty,
  setProperties,
  getProperties,
  setSiteName,
  getSiteName,
  getCustomColorPalettes,
  setCustomColorPalettes,
  getCurrentColorPaletteVersion,
  setCurrentColorPaletteVersion,
  getCustomTextColors,
  setCustomTextColors,
  getCustomColors,
  setCustomColors,
  getCustomFontPairs,
  setCustomFontPairs,
  getCustomGradients,
  setCustomGradients,
  getCleanUrlsEnabled,
  setCleanUrlsEnabled,
  getRedirects,
  setRedirects,
  getIntegrations,
  setIntegrations,
  getCurrentButtonPresetVersion,
  setCurrentButtonPresetVersion,
};
